import { useEffect, useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from './ui/dialog';
import { Button } from './ui/button';
import { Clock } from 'lucide-react';

/**
 * SessionTimeoutDialog
 * -----------------------------------------------------------------------------
 * Modal de aviso de cierre de sesion por inactividad (21 CFR Part 11 / GDPR).
 * Cuenta atras final (WARNING_BEFORE_MS) antes de expulsar al usuario.
 * El boton "Continuar sesion" reinicia el temporizador de inactividad.
 * -----------------------------------------------------------------------------
 */
export default function SessionTimeoutDialog({ open, remainingMs, onExtend, onLogoutNow }) {
  const [seconds, setSeconds] = useState(0);

  useEffect(() => {
    if (!open) return;
    setSeconds(Math.max(0, Math.ceil(remainingMs / 1000)));
    const iv = setInterval(() => {
      setSeconds(s => (s > 0 ? s - 1 : 0));
    }, 1000);
    return () => clearInterval(iv);
  }, [open, remainingMs]);

  return (
    <Dialog open={open} onOpenChange={() => { /* no cerrar por click fuera */ }}>
      <DialogContent
        data-testid="session-timeout-dialog"
        className="sm:max-w-md"
        onInteractOutside={(e) => e.preventDefault()}
        onEscapeKeyDown={(e) => e.preventDefault()}
      >
        <DialogHeader>
          <div className="flex items-center gap-2">
            <Clock className="h-5 w-5 text-amber-600" />
            <DialogTitle>Sesion a punto de expirar</DialogTitle>
          </div>
          <DialogDescription>
            Por seguridad, tu sesion se cerrara automaticamente por inactividad.
          </DialogDescription>
        </DialogHeader>
        <div className="py-4 text-center">
          <div className="text-4xl font-bold text-[#1f3e80]" data-testid="session-timeout-countdown">
            {String(Math.floor(seconds / 60)).padStart(2, '0')}:{String(seconds % 60).padStart(2, '0')}
          </div>
          <div className="text-sm text-stone-500 mt-2">
            Pulsa &quot;Continuar sesion&quot; para seguir trabajando.
          </div>
        </div>
        <DialogFooter className="flex-col sm:flex-row gap-2">
          <Button
            variant="outline"
            onClick={onLogoutNow}
            data-testid="session-timeout-logout-btn"
          >
            Cerrar sesion ahora
          </Button>
          <Button
            onClick={onExtend}
            className="bg-[#1f3e80] hover:bg-[#1a3670]"
            data-testid="session-timeout-extend-btn"
          >
            Continuar sesion
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
